<template>
  <b-container fluid>
    <div id="module-form">
      <b-row v-if="isAdmin || isSRC">
        <b-col cols="5">
          <b-form-group class="m-4">
            <label for="module_date">Date</label>
            <b-form-input
              name="module_date"
              type="date"
              id="date"
              v-model="dateForm"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group class="m-4">
            <div v-if="type == 'maintenance'">
                <label for="training">Activites</label>
              <br />
              <b-form-select v-model="activityForm" name="training">
                <option disabled value>Select  
                  <span>Activity</span>
                </option>
                <option
                  v-for="(activity, index) in activities"
                  :key="index"
                  :value="activity"
                  >{{ activity }}</option
                >
              </b-form-select>
            </div>
            <label v-if="type=='module'" for="training">Training</label>
            <label v-else for="training">Episodes</label>
            <br />
            <b-form-select v-model="courseForm" name="training">
              <option disabled value>Select  
                <span v-if="type=='module'">a Training</span>
                <span v-else>a Episode</span>
              </option>
              <option
                v-for="(course, index) in courses"
                :key="index"
                :value="course"
                >{{ course }}</option
              >
            </b-form-select>
            <b-form-group class="mt-4">
              <div id="selected-teachers">
                <label for="selected-teachers">Teachers in Attendance:</label>
                <b-table
                  v-cloak
                  responsive
                  :fields="teacherAttendanceFields"
                  :items="teachersNames"
                  :striped="true"
                  :bordered="true"
                  :hover="true"
                  stacked="md"
                  small
                >
                  <template slot="cell(delete)" slot-scope="row">
                    <b-link
                      class="delete"
                      @click.stop="deleteTeacherFromModule(row.item)"
                      >DEL</b-link
                    >
                  </template>
                </b-table>
              </div>
            </b-form-group>
            <b-button
              variant="primary"
              block
              class="mt-2"
              @click="addOrUpdate"
              >
              <span v-if="type=='module'">{{ buttonTitle }}</span>
              <span v-else>Add Maintenance Activity</span>
            </b-button
            >
            <b-button variant="danger" block class="mt-2" @click="clearForm()"
              >Cancel</b-button
            >
          </b-form-group>
        </b-col>
        <b-col>
          <div class="table-wrap">
            <br />
            <h4 class="subtitle">Add Teachers</h4>
            <name-search parent="tm" table="teachers"></name-search>
            <br />
            <group-search table="teachers"></group-search>
            <br />
            <div id="alerts" ref="alert">
              <b-alert
                :show="dismissCountDown"
                dismissible
                variant="success"
                @dismissed="dismissCountDown = 0"
                @dismiss-count-down="countDownChanged"
                >You have successfully added a teacher!</b-alert
              >
              <b-alert :show="showError" dismissible variant="warning">
                Something went wrong. Please refresh and try again, or contact
                the site admin.
              </b-alert>
            </div>
            <b-col v-if="cleanedSearchResults.length">
              <h6 class="subtitle">
                Results: {{ getTeacherSearchResults.length }} teachers found
              </h6>
              <b-form-group>
                <b-input-group>
                  <b-form-input
                    v-model="filterSearchResults"
                    placeholder="Type to Search"
                  />
                  <b-input-group-append>
                    <b-btn
                      :disabled="!filterSearchResults"
                      @click="filterSearchResults = ''"
                      >Clear</b-btn
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-table
              v-cloak
              responsive
              :fields="searchResultsFields"
              :items="cleanedSearchResults"
              :striped="true"
              :bordered="true"
              :hover="true"
              stacked="md"
              small
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filterSearchResults"
              @filtered="onFilteredResults"
            >
              <template slot="cell(first_name)" slot-scope="row">
                <b-link
                  @click.stop="stopClick"
                  :to="{
                    name: 'EditTeacher',
                    params: { id: row.item.teacher_id }
                  }"
                  >{{ row.item.teacher_name }}</b-link
                >
                <br />
                <p class="small-date">created: {{ row.item.created }}</p>
                <p class="small-date">
                  Head Teacher?:
                  {{ row.item.head_teacher === true ? "Y" : "F" }}
                </p>
              </template>
              <template slot="cell(sex)" slot-scope="row">
                {{ row.item.sex === "male" ? "M" : "F" }}
              </template>
              <template slot="cell(id)" slot-scope="row">
                <b-link class="add" @click.stop="addTeacherToModule(row.item)"
                  >ADD</b-link
                >
              </template>
            </b-table>
            <b-row>
              <b-col md="6" class="my-1">
                <b-pagination
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="table-wrap">
            <br />
            <h4 v-if="type=='module'" class="subtitle">Standard Module</h4>
            <h4 v-else class="subtitle">Maintenance Activities</h4>
            <b-col>
              <h6 class="subtitle">
                Results: {{ trainings.length }} 
                  <span v-if="type=='module'">module</span>
                  <span v-else>activities</span> 
                found
              </h6>
              <b-form-group>
                <b-input-group>
                  <b-form-input
                    v-model="trainingFilter"
                    placeholder="Type to Search"
                  />
                  <b-input-group-append>
                    <b-btn
                      :disabled="!trainingFilter"
                      @click="trainingFilter = ''"
                      >Clear</b-btn
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-table
              v-cloak
              responsive
              :fields="trainingFields"
              :items="trainings"
              :striped="true"
              :bordered="true"
              :hover="true"
              stacked="md"
              small
              :current-page="currentPage"
              :per-page="perPage"
              :filter="trainingFilter"
              @filtered="onFilteredResults"
            >
              <template slot="cell(participants)" slot-scope="row">
                {{ row.item.teachers_uuid.length }}
              </template>
              <template slot="cell(id)" slot-scope="row">
                <b-link
                  v-if="isAdmin || isSRC"
                  class="edit"
                  @click.stop="editModule(row)"
                  >EDIT</b-link
                >
              </template>
              <template slot="cell(delete)" slot-scope="row">
                <b-link
                  v-if="isAdmin || isSRC"
                  class="delete"
                  @click.stop="deleteModule(row.item)"
                  >DELETE</b-link
                >
              </template>
            </b-table>
            <b-row>
              <b-col md="6" class="my-1">
                <b-pagination
                  :total-rows="trainingRows"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TrainerService from "@/services/TrainerService";
import { flash } from "@/mixins/flashes";
import { scrollTo } from "@/mixins/scrollTo";

export default {
  name: "TrainingModules",
  mixins: [flash, scrollTo],
  components: {
    NameSearch: () => import("@/components/NameSearch"),
    GroupSearch: () => import("@/components/GroupSearch")
  },
  props:["type"],
  data() {
    return {
      dateForm: null,
      courseForm: "",
      teachersForm: [],
      teacherNames: [],
      courses: [],
      // [
      //   "Introduction",
      //   "Planning",
      //   "Working with Parents",
      //   "Language and Communication",
      //   "Perceptual - Auditory",
      //   "Perceptual - Visual",
      //   "Body Image",
      //   "Inclusion Management",
      //   "Activity Areas",
      //   "Learning",
      //   "Hygiene",
      //   "Environment",
      //   "Wellness and Safety",
      //   "School Preparation 1",
      //   "Gender Inclusion",
      //   "School Preparation 2"
      // ]
      schoolTeacherFields: [
        { key: "first_name", label: "name", sortable: true },
        { key: "head_teacher", label: "HT?", sortable: true },
        { key: "active", label: "Active?", sortable: true },
        { key: "delete", label: "DELETE" }
      ],
      searchResultsFields: [
        { key: "first_name", label: "name", sortable: true },
        { key: "sex", label: "sex", sortable: true },
        { key: "id", label: "ADD" }
      ],
      trainingFields: [
        { key: "tm_date", label: "Date", sortable: true },
        { key: "course", label: "Course", sortable: true },
        { key: "participants", label: "Number of participants" },
        { key: "id", label: "EDIT" },
        { key: "delete", label: "DEL" }
      ],
      teacherAttendanceFields: [
        { key: "teacher_name", label: "Teacher Name", sortable: true },
        { key: "delete", label: "DELETE" }
      ],
      currentPage: 1,
      country: "",
      perPage: 20,
      pageOptions: [20, 50, 100],
      filter: null,
      filterSearchResults: null,
      trainingFilter: null,
      totalRows: this.rows,
      teachersNames: [],
      teachersIds: [],
      formError: false,
      changeTitle: false,
      buttonTitle: "Add Training Module",
      trainingFieldTitle: "Activity",
      activities:["Super Sema"],
      activityForm: null
    };
  },
  methods: {
    ...mapActions({
      RESET_SEARCH: "searches/RESET_SEARCH_STATE",
      GET_TRAINER_MODULES: "trainers/GET_TRAINER_MODULES",
      GET_OPTIONS: "optionsList/GET_OPTIONS"
    }),
    getCourses() {
      this.courses = [];
      this.optionsList.forEach(element => {
        if(this.type == "module"){
          if (element.key == "modules") {
            this.id = element.id;
            element.values.forEach(value => {
              this.courses.push(value);
            });
          }
        }else{
             if (element.key == "superSemaEpisodes") {
            this.id = element.id;
            element.values.forEach(value => {
              this.courses.push(value);
            });
          }
        }
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredResults(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    addTeacherToModule(row) {
      if (
        this.teachersIds.includes(row.uuid) ||
        this.teachersNames.includes(row.teacher_name)
      ) {
        return;
      }
      this.teachersIds.push(row.id);
      this.teachersNames.push({ teacher_name: row.teacher_name, id: row.uuid });
    },
    clearForm() {
      this.dateForm = null;
      this.courseForm = "";
      this.teachersIds = [];
      this.teachersNames = [];
    },
    async deleteTeacherFromModule(row) {
      this.teachersIds.splice(this.teachersIds.indexOf(row.id), 1);
      this.teachersNames = this.teachersNames.filter(
        key => key.teacher_name !== row.teacher_name
      );
    },
    async editModule(row) {
      const module = await TrainerService.fetchOneTrainerModule(row.item.id);
      const data = module.data.results;
      const names = data.teacher_names;

      this.teachersNames = [];

      for (let i = 0; i < names.length; i++) {
        this.teachersNames.push({ teacher_name: names[i] });
      }
      this.id = data.id;
      this.dateForm = data.tm_date;
      this.courseForm = data.course;
      this.buttonTitle = "Edit Training";
    },
    async addTrainingModule() {
      if (this.dateForm && this.teachersIds.length) {
        const payload = {
          date: this.dateForm,
          trainer_uuid: this.$route.params.id,
          teachers_uuid: this.teachersIds,
          course: this.courseForm,
          type: this.type
        };
        await TrainerService.addTrainerModule(payload);
        await this.scrollTo("alert");
        await this.flashSuccess();
        this.clearForm();
        this.formError = false;
        this.changeTitle = false;
        await this.RESET_SEARCH();
        await this.GET_TRAINER_MODULES();
      } else {
        this.formError = true;
        this.flashError();
      }
    },
    async updateTrainerModule(row) {
      if (this.dateForm && this.teachersIds.length) {
        const payload = {
          id: this.id,
          date: this.dateForm,
          trainer_uuid: this.$route.params.id,
          teachers_uuid: this.teachersIds,
          course: this.courseForm
        };
        await TrainerService.updateTrainerModule(payload);
        await this.scrollTo("alert");
        await this.flashSuccess();
        this.clearForm();
        this.formError = false;
        this.changeTitle = false;
        await this.RESET_SEARCH();
        await this.GET_TRAINER_MODULES();
      } else {
        this.formError = true;
        this.flashError();
      }
    },
    async deleteModule(params) {
      const confirmDelete = confirm(
        "Are you sure you want to delete this training module record?"
      );
      if (confirmDelete) {
        await TrainerService.deleteTrainerModule(params.id);
        await this.GET_TRAINER_MODULES();
      }
    },

    addOrUpdate() {
      if (this.buttonTitle === "Add Training Module") {
        this.addTrainingModule();
      } else {
        this.updateTrainerModule();
      }
    },
    filterTrainings(){
      var trainings;
      if(this.type =='maintenance'){
        trainings = this.$store.state.trainers.trainerModules.filter(p=> p.type === 'maintenance');
      }else{
        trainings = this.$store.state.trainers.trainerModules.filter(p=> p.type === null || p.type === 'module');
      }
      return trainings;
    },
    stopClick(row) {}
  },
  computed: {
    ...mapGetters({
      getTeacherSearchResults: "searches/getTeacherSearchResults",
      isAdmin: "auth/isAdmin",
       isSRC: "auth/isSRC",
    }),
    trainings: {
      get() {
        return this.filterTrainings();
      }
    },
    optionsList: {
      get() {
        return this.$store.state.optionsList.optionsList;
      }
    },
    cleanedSearchResults() {
      const data = this.getTeacherSearchResults.map(k => ({
        id: k.uuid,
        teacher_name: `${k.first_name} ${k.middle_name} ${k.last_name}`,
        head_teacher: k.head_teacher,
        active: k.active,
        sex: k.sex,
        created: k.created
      }));
      return data;
    },
    trainingRows() {
      if (this.trainings.length && this.trainings.length > 0) {
        return this.trainings.length;
      }
    },
    rows() {
      if (this.teachers.length > 0) {
        return this.teachers.length;
      }
    },
    sortOptions() {
      // Create an options list from our fields
      return this.schoolTeacherFields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    }
  },
  async mounted() {
    this.RESET_SEARCH();
    await this.GET_TRAINER_MODULES();
    await this.GET_OPTIONS();
    this.getCourses();
  }
};
</script>
